module.exports = __webpack_public_path__ + "static/media/38_tn.995448bc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/38_tn.jpg
// module id = 674
// module chunks = 0